var _excluded = ["children", "render", "component"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { Tracker as BaseTracker, TrackRoute as TrackRouteCore, TrackEvent, browser, context, session, holmes, combineCollects, print, composeProvider } from '@ecomfe/react-track';
import { Route, useParams } from 'react-router-dom';
import dataCenter from './dataCenter'; // eslint-disable-next-line

import { jsx as _jsx } from "react/jsx-runtime";
window.__icloud__ = window.__icloud__ ? window.__icloud__ : {}; // eslint-disable-next-line

var _window$__icloud__ = window.__icloud__,
    isOnline = _window$__icloud__.isOnline,
    store = _window$__icloud__.store;
var baseCollects = [browser(), session()];
var trackDataCenterProvider = isOnline ? dataCenter('https://ee-dc-receiver.baidu-int.com/v2/log') : print();
var trackBaiduStatisticsProvider = isOnline // eslint-disable-next-line
? holmes(window.__POWERED_BY_QIANKUN__ ? '52c706834df0558107d092af15fa81cd' : 'ce5277dbfe1a3b7bffcc9b5e697f81f6') : print();
var provider = composeProvider(trackDataCenterProvider, trackBaiduStatisticsProvider);
/**
 * 切换账户时使用，判断path是否有params，有参数时会直接刷新，否则不满足其他特定条件时指向产品线主页
 * @param any
 * @returns ReactElement
 */

var RecordRouterMatch = function RecordRouterMatch(_ref) {
  var children = _ref.children;
  var params = useParams(); // eslint-disable-next-line

  window.__icloud__.routeMatch = {}; // eslint-disable-next-line

  window.__icloud__.routeMatch.params = params;
  return children;
};

function TrackRoute(_ref2) {
  var children = _ref2.children,
      render = _ref2.render,
      component = _ref2.component,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(Route, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(RecordRouterMatch, {
      children: /*#__PURE__*/_jsx(TrackRouteCore, _objectSpread(_objectSpread({
        render: render,
        component: component
      }, props), {}, {
        children: children
      }))
    })
  }));
}

TrackRoute.displayName = "TrackRoute";
export { TrackRoute, TrackEvent };
export function Tracker(_ref3) {
  var _store$getState;

  var children = _ref3.children,
      _ref3$buildVersion = _ref3.buildVersion,
      buildVersion = _ref3$buildVersion === void 0 ? '' : _ref3$buildVersion,
      _ref3$buildTime = _ref3.buildTime,
      buildTime = _ref3$buildTime === void 0 ? '' : _ref3$buildTime,
      _ref3$buildTarget = _ref3.buildTarget,
      buildTarget = _ref3$buildTarget === void 0 ? '' : _ref3$buildTarget;

  var _useState = useState(store === null || store === void 0 ? void 0 : (_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : _store$getState.detail),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _ref4 = state || {},
      currentAccount = _ref4.currentAccount,
      login = _ref4.login,
      moduleName = _ref4.moduleName;

  var refreshStore = useCallback(function () {
    var _store$getState2;

    setState(store === null || store === void 0 ? void 0 : (_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : _store$getState2.detail);
  }, []);
  useEffect(function () {
    var unsubscribe = store === null || store === void 0 ? void 0 : store.subscribe(refreshStore);
    return function () {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [refreshStore]);
  var collect = useMemo(function () {
    var app = {
      app: 'lsqm-console',
      module: moduleName,
      version: buildVersion + '@' + buildTime,
      environment: buildTarget,
      username: login === null || login === void 0 ? void 0 : login.username,
      accountUuid: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.accountUuid,
      accountName: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.accountName
    };
    return combineCollects.apply(void 0, [context(app)].concat(baseCollects));
  }, [currentAccount, login, moduleName, buildVersion, buildTime, buildTarget]);
  return /*#__PURE__*/_jsx(BaseTracker, {
    collect: collect,
    provider: provider,
    children: children
  });
}
Tracker.displayName = "Tracker";
//# sourceMappingURL=es/Tracker.js.map